export default __webpack_public_path__ + "static/media/location.965bf3d7.svg";